import { Badge } from "../types/users";
import { Itter } from "../utils/utils";

export default function extraBadges(length: number) {
  return Itter<Badge>(length, (i) => ({
    name: "",
    image: i.toString(),
    lore: ""
  }))
}